import React from "react";
import BigMessage from "@/components/BigMessage";
import { useTheme } from "@/components/ThemeProvider";
import classNames from "classnames";
import "./LoadingState.less";

// Default "loading" message for list pages
export default function LoadingState(props) {
  const { isDarkMode } = useTheme();

  return (
    <div className={classNames("loading-state", { "dark-mode": isDarkMode })}>
      <BigMessage icon="fa-spinner fa-2x fa-pulse" message="Loading..." {...props} />
    </div>
  );
}
